import { render, staticRenderFns } from "./PageHomeBed.vue?vue&type=template&id=00138e00&scoped=true&"
import script from "./PageHomeBed.vue?vue&type=script&lang=js&"
export * from "./PageHomeBed.vue?vue&type=script&lang=js&"
import style0 from "./PageHomeBed.vue?vue&type=style&index=0&id=00138e00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00138e00",
  null
  
)

export default component.exports